
export const SymptomsCheckerConstants = {
    SERVICE_URL : 'https://api.bcbsal.org',
    API_KEY : '557-53fe1a15-42ef-4133-808e-438800ebcf8c',

    // Diagnosis Service
    SUGGEST_SERVICE : {
        DiagnosisAPI : '/private/emr_diagnosis.jsp?searchType=0&specialties=28&suggest=Suggest+Differential+Diagnosis&web_service=json&flag=sortbyRW_advanced&callback=JSONP_CALLBACK',
    },

    // Know Where to go service
    TRIAGE_TOOL_SERVICE : {
        TriageToolAPI : '/suggest_diagnoses_advanced/triage_tool_bb?'
    },

    // Symptom Details Services
    EBSCO_Services: {
        SymptomDetailsAPI : 'https://api.bcbsal.org/HealthHandbook/SymptomDetail?',
        ArticleDetailsAPI  : 'https://api.bcbsal.org/HealthHandbook/ArticleDetail?db=hlt',
        ContentSearchAPI : 'https://api.bcbsal.org/HealthHandbook/ContentSearch?db=hlt&'
    },

    // Symptom Suggestion Service
    SOLR_Services: {
        SymptomSuggestionAPI : '/symptomChecker/suggest?indent=on&suggest.build=true&suggest.dictionary=symptomSuggester&wt=json'
    },

     // this might be required if needed in future
    FormGroup_SERVICE : {
        'AgeGroupAPI': '/suggest_diagnoses_advanced/get_service_age_groups?language=english&web_service=json&callback=JSONP_CALLBACK',
        'RegionGroupAPI': '/suggest_diagnoses_advanced/get_service_regions?language=english&web_service=json&callback=JSONP_CALLBACK',
        'PregnanciesAPI': '/suggest_diagnoses_advanced/get_service_pregnancies?language=english&web_service=json&callback=JSONP_CALLBACK'
    }
};






// WEBPACK FOOTER //
// ./src/app/common/symptomCheckerConstants.ts